import { Client } from 'urql'
import { queryAllFeatureTypeConfigsForFilter } from '../feature-types/featureTypesConfigQueries'
import { Feature_Type_Config, Mutation_Root, Query_Root } from 'src/@types/graphql'
import { Option } from 'src/shared/form/control'
import { SupportedLocale } from 'src/@types'
import { sortBy } from 'lodash'
import { deleteFeatureConfigById } from 'src/screens/administration/configuration-management/features-configuration/features/featuresConfigQueries'

export const mapAllFeatureTypesToOptions = (featureTypes: Feature_Type_Config[], locale: SupportedLocale): Option[] =>
  featureTypes.map((ftc) => ({
    label: ftc.names[locale],
    value: ftc.id,
  }))

export const fetchAllFeatureTypes = (urqlClient: Client, locale: SupportedLocale) => async () => {
  const { data, error } = await urqlClient
    .query<{
      feature_type_config: Query_Root['feature_type_config']
    }>(queryAllFeatureTypeConfigsForFilter, {})
    .toPromise()

  if (error || !data?.feature_type_config) {
    throw new Error('Resource not found')
  }

  const fetchedFeatureTypes = sortBy(data.feature_type_config, [`names.${locale}`])
  return { fetchedFeatureTypes }
}

export const deleteFeatureConfig = (urqlClient: Client) => async (featureConfigId: number) => {
  const { data, error } = await urqlClient
    .mutation<{ delete_feature_config: Mutation_Root['delete_feature_config'] }, { featureConfigId: number }>(
      deleteFeatureConfigById,
      { featureConfigId },
    )
    .toPromise()

  if (error || data?.delete_feature_config?.affected_rows !== 1) {
    throw new Error('Feature config deletion error')
  }

  return true
}
